import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {DeleteLinkTileCommand, DeleteLinkTilePayload} from "../commands/delete-link-tile.command";

/**
 * Serialises a DeleteLinkTileCommand into the backend command DTO.
 *
 * A dedicated transformer is REQUIRED, not a nicety. Without one the generic
 * command→DTO fallback runs, and that fallback demands a change-tracked proxy
 * as the payload — these commands carry a plain object, so it throws
 * "The payload of the command must be a proxified object". The throw happens
 * OUTSIDE the CommandBus's try block, which wedges the bus for the rest of the
 * session rather than failing the one command.
 *
 * The full envelope is emitted, not just the payload: inside a bulk each
 * sub-command is re-built through the command factory on the server, so every
 * element needs `name`, `uid`, `mainEntityClass` and `mainEntityUid` exactly
 * like an outer command.
 */
@injectable()
@transformer({
    source: DeleteLinkTileCommand,
    target: `dto`
})
export class DeleteLinkTileCommandToDtoTransformer implements TransformerInterface<CommandDTO<DeleteLinkTilePayload>, DeleteLinkTileCommand> {

    public async transform(command: DeleteLinkTileCommand): Promise<CommandDTO<DeleteLinkTilePayload>> {
        return <CommandDTO<DeleteLinkTilePayload>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: command.payload,
        };
    }
}
